import React from "react";
import ai from "../../assets/image/Images/ai.jpg";

const ContentTwo = ({ className, ...rest }) => {
  return (
    <div className={className} {...rest}>
      <div className="container">
        <div className="row pt-lg-10 align-items-center justify-content-center">
          <div
            className="col-xl-6 col-lg-6 col-xs-12"
            data-aos="fade-right"
            data-aos-delay={100}
          >
            <div className="mt-5 mt-lg-0">
              <div className="img-2">
                <img className="rounded-10 w-100 w-lg-auto" src={ai} alt="interactive images and artificial intelligence (A.I)" />
              </div> 
            </div>
          </div>
          <div
            className="col-xl-6 col-lg-6 col-xs-12"
            data-aos="fade-left"
            data-aos-delay={100}
          >
            <div className="pl-lg-15 pt-11 pt-lg-0">
              <h2 className="font-size-10 mb-2">
                A.I.
              </h2>
              <p className="font-size-6 mb-5">
              After uploading your image our plaform will automaticaly create a bundle of information that has been gathered from the A.I. 
              </p>
              <table className="mt-5 text-black" cellPadding="5">
              <tr>
                <td><i className="fa fa-check mr-4 bg-image border-0 text-white" /></td>
                <td>Identifies thousands of objects</td>
              </tr>
              <tr>
                <td><i className="fa fa-check mr-4 bg-image border-0 text-white" /></td>
                <td>Celebrity recognition</td>
              </tr>
              <tr>
                <td><i className="fa fa-check mr-4 bg-image border-0 text-white" /></td>
                <td>Locate and extract text within images</td>
              </tr>                
              <tr>
                <td><i className="fa fa-check mr-4 bg-image border-0 text-white" /></td>
                <td>Unsafe image detection</td>
              </tr>                                        
            </table>               
              <div className="mt-9">
                <a className="btn bg-image text-white btn-xl h-55 rounded-5" href="https://app.digma.io?mode=login/">
                try for free
                </a>
               </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContentTwo;
